export type FrequenciaRecorrencia = | 'Diário' | 'Semanal' | 'Mensal' | 'Anual' | 'Personalizada';
export type TipoTerminoRecorrencia = 'Nunca' | 'Data' | 'N. de Envios';
export type TipoRecorrenciaMensal = 'Dia do Mês' | 'Dia da Semana';
export type PosicaoSemanaMes = | 'Primeira' | 'Segunda' | 'Terceira' | 'Quarta' | 'Quinta' | 'Última';
export type UnidadePersonalizada = 'Dia' | 'Semana' | 'Mês';

export interface OpcaoSegmento<T = string> {
  valor: T;
  label: string;
}

export const FREQUENCIAS: OpcaoSegmento<FrequenciaRecorrencia>[] = [
  { valor: 'Diário', label: 'Diário' },
  { valor: 'Semanal', label: 'Semanal' },
  { valor: 'Mensal', label: 'Mensal' },
  { valor: 'Anual', label: 'Anual' },
  { valor: 'Personalizada', label: 'Personalizada' },
];

export const TERMINOS: OpcaoSegmento<TipoTerminoRecorrencia>[] = [
  { valor: 'Nunca', label: 'Nunca' },
  { valor: 'Data', label: 'Data' },
  { valor: 'N. de Envios', label: 'N. de Envios' },
];

export const TIPO_RECORRENCIA_MENSAL: Record<'DIA_DO_MES' | 'DIA_DA_SEMANA',  TipoRecorrenciaMensal> = {
  DIA_DO_MES: 'Dia do Mês',
  DIA_DA_SEMANA: 'Dia da Semana',
};

export const POSICOES_SEMANA_MES: OpcaoSegmento<PosicaoSemanaMes>[] = [
  { valor: 'Primeira', label: 'Primeira' },
  { valor: 'Segunda', label: 'Segunda' },
  { valor: 'Terceira', label: 'Terceira' },
  { valor: 'Quarta', label: 'Quarta' },
  { valor: 'Quinta', label: 'Quinta' },
  { valor: 'Última', label: 'Última' },
];

export const UNIDADES_PERSONALIZADA: OpcaoSegmento<UnidadePersonalizada>[] = [
  { valor: 'Dia', label: 'Dia' },
  { valor: 'Semana', label: 'Semana' },
  { valor: 'Mês', label: 'Mês' },
];

export const DIAS_SEMANA_MES: OpcaoSegmento<number>[] = [
  { valor: 0, label: 'Segunda-Feira' },
  { valor: 1, label: 'Terça-Feira' },
  { valor: 2, label: 'Quarta-Feira' },
  { valor: 3, label: 'Quinta-Feira' },
  { valor: 4, label: 'Sexta-Feira' },
  { valor: 5, label: 'Sábado' },
  { valor: 6, label: 'Domingo' },
];
